import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import TagsIcon from "../../assets/icons/tags";
import CloseIcon from "../../assets/icons/cross";
import { useDispatch, useSelector } from "react-redux";
import { manageQuoteModal } from "../../redux/common/slice";
import { handleApiRequest } from "../../services/handleApiRequest";
import { getQuoteOfTheDay } from "../../redux/common/thunk";
import { ClipLoader } from "react-spinners";
import { successMsg } from "../../utils/toastMessage";

const QuoteModal = () => {
  const dispatch = useDispatch();

  const { openQuoteModal } = useSelector((state) => state.common);
  const [quote, setQuote] = useState({});
  const [loading, setLoading] = useState(false);

  const handleClosePop = () => {
    dispatch(manageQuoteModal(false));
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(quote.body);
    successMsg("Copied to clipboard");
  };

  useEffect(() => {
    if (!openQuoteModal) return;

    (async () => {
      setLoading(true);
      const response = await handleApiRequest(getQuoteOfTheDay);
      setLoading(false);

      if (response.status) {
        setQuote(response?.data?.data || {});
      }
    })();
  }, [openQuoteModal]);

  return (
    <>
      <Modal
        show={openQuoteModal}
        onHide={handleClosePop}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        className="quote-modal">
        <Modal.Body className="position-relative">
          {loading ? (
            <div className="text-center my-5">
              <ClipLoader
                color={"var(--primary-color)"}
                cssOverride={{ borderWidth: 5 }}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
          ) : (
            <>
              <CloseIcon
                className="pointer position-absolute top-0 end-0 img-small img-thumbnail mt-2 me-2"
                onClick={handleClosePop}
              />
              <div className="pb-3 pt-4 mt-2 px-lg-5">
                <h2 className="pop-head m-0 pb-2">{quote?.body}</h2>
                <h4 className="text-center my-3">-{quote?.author}</h4>
                {quote.tags?.length > 0 && (
                  <p className="text-center">
                    Tags
                    <TagsIcon className="ms-1 me-3" />
                    <span className="text-secondary">{quote.tags?.join(", ")}</span>
                  </p>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center mb-3">
                <button className="primaryBtn rounded px-3 py-1" onClick={handleCopy}>
                  Copy to Clipboard
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default QuoteModal;
